import React from 'react';
import { Stack, Flex, Title } from '@mantine/core';

interface SurveyActivityDrawerHeaderProps {
    zoneName: string;
}

export function SurveyActivityDrawerHeader({
    zoneName,
}: SurveyActivityDrawerHeaderProps) {
    return (
        <Stack className="gap-1 w-full">
            <Title
                order={2}
                className="text-xl font-bold m-0 text-gray-900 leading-none"
            >
                Activity History
            </Title>
            <Flex className="flex-row items-center gap-2 text-sm text-gray-500">
                <span>{zoneName}</span>
            </Flex>
        </Stack>
    );
}
